import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Yo siempre terminaba respondiendo consultas de forma distinta según el día. Tener estructuras claras me bajó muchísimo el desgaste mental.',
  name: 'Valeria P.',
  role: 'Peluquera independiente — Buenos Aires'
}, {
  quote: 'Lo que más me gustó fue que no son cosas lindas para mirar. Son herramientas para usar de verdad.',
  name: 'Marina T.',
  role: 'Dueña de salón — Córdoba'
}, {
  quote: 'Sentís alivio cuando dejás de tener que inventar soluciones para todo.',
  name: 'Romina F.',
  role: 'Estilista profesional — Rosario'
}, {
  quote: 'Yo técnicamente sabía trabajar. Lo que me faltaba era estructura. Ahí estuvo el cambio.',
  name: 'Carla M.',
  role: 'Home Studio'
}, {
  quote: 'Mis clientas empezaron a notar más claridad incluso en cómo explicaba procesos o presupuestos.',
  name: 'Julieta R.',
  role: 'Colorista / estilista'
}, {
  quote: 'El sistema completo me ahorró muchísimo tiempo porque muchas cosas ya estaban listas.',
  name: 'Sofía L.',
  role: 'Peluquera independiente'
}];
export function TestimonialsPreGuarantee() {
  return <section className="bg-white py-8 px-5" data-id="element-316">
      <div className="max-w-4xl mx-auto" data-id="element-317">
        <h2 className="text-2xl md:text-3xl font-black text-center text-slate-900 mb-4" data-id="element-318">
          💬 PROFESIONALES REALES, SITUACIONES REALES
        </h2>
        <p className="text-sm text-slate-400 text-center mb-12 font-bold uppercase tracking-widest" data-id="element-319">
          No se trata solo de aprender más. Se trata de trabajar distinto.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-320">
          {comments.map((c, i) => <div key={i} className="bg-slate-50 border border-slate-100 p-6 rounded-2xl transition-all hover:bg-white hover:shadow-lg flex flex-col justify-between" data-id="element-321">
              <div data-id="element-322">
                <div className="flex gap-1 mb-3" data-id="element-323">
                  {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-brand-accent text-brand-accent" data-id="element-324" />)}
                </div>
                <p className="text-slate-600 italic text-sm mb-6 leading-relaxed font-medium" data-id="element-325">
                  "{c.quote}"
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-326">
                <div className="w-8 h-8 rounded-full bg-brand-primary/10 flex items-center justify-center text-brand-primary font-bold text-xs" data-id="element-327">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-328">
                  <p className="font-bold text-slate-900 text-xs" data-id="element-329">{c.name}</p>
                  <p className="text-[9px] text-slate-400 font-black uppercase tracking-widest" data-id="element-330">
                    {c.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}